import { Link } from "react-router-dom";
import type { Business } from "@/types";
import BusinessCard from "@/components/feature/BusinessCard";

export default function RecentlyAdded({ businesses }: { businesses: Business[] }) {
  return (
    <section className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-16">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-secondary-700">
            <span className="h-1 w-1 rounded-full bg-primary-500"></span>
            Freshly added
          </span>
          <h2 className="font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-3xl">
            Recently added businesses
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            New shops, services and stays that joined the directory this week across{" "}
            Mysore, Mandya, Chamarajanagar and Kodagu.
          </p>
        </div>
        <Link
          to="/directory?sort=newest"
          className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors duration-200 hover:border-primary-300 hover:bg-primary-50 hover:text-primary-800 cursor-pointer"
        >
          See more listings
          <i className="ri-arrow-right-line text-base transition-transform duration-200 group-hover:translate-x-0.5"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {businesses.slice(0, 12).map((b) => (
          <BusinessCard key={b.id} business={b} badge="none" />
        ))}
      </div>
    </section>
  );
}